export const Environment = {
    local: 'local',
    localNoBackend: 'local-no-backend',
    development: 'development',
    qa: 'qa',
    production: 'production'
}
  